/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IconButton, Buttons, FloatingPopUp, Label, Bid, Loader } from 'components';
import { showPolipop, isBidErrorShown, isInvalidBid, trimDecimal } from 'utils';
import { campaignReportsAPI } from 'services/campaignReports.service';
import { Pen, LampIcon } from 'assets/icons';

import * as S from './ChangeBid.styled';

export const ChangeBid = ({ bidValue, minBid, displayMinBid = minBid, maxBid, isCpm }) => {
  const [isOpen, setIsOpen] = useState(false);

  const triggerComponentRef = useRef(null);

  const closeAction = () => {
    setIsOpen(false);
  };

  return (
    <FloatingPopUp
      durationValue={50}
      isArrow
      offsetValue={10}
      defaultPlacement={FloatingPopUp.placements.top}
      isOpen={isOpen}
      closeAction={closeAction}
      popUpComponent={
        <TooltipContent
          closeAction={closeAction}
          bidValue={bidValue}
          minBid={minBid}
          displayMinBid={displayMinBid}
          maxBid={maxBid}
          isCpm={isCpm}
        />
      }
      triggerStyle={{ zIndex: isOpen && 2100 }}
      triggerComponent={
        <IconButton.Micro
          onClick={() => setIsOpen((prev) => !prev)}
          ref={triggerComponentRef}
          icon={Pen}
          type={IconButton.btnTypes.tertiary}
          isPressed={isOpen}
        />
      }
    />
  );
};

const TooltipContent = ({ closeAction, bidValue, minBid, displayMinBid, maxBid, isCpm }) => {
  const { cmp_id } = useParams();
  const [bid, setBid] = useState(bidValue);

  const [updateCampaignBid, result] = campaignReportsAPI.useUpdateCampaignBidMutation();

  const isError = isBidErrorShown(bid, minBid, maxBid);
  // admin may save below the publisher minimum, but is warned about it (doesn't disable save)
  const isMinBidWarning = isBidErrorShown(bid, displayMinBid, maxBid);
  const isDisabled = isInvalidBid(bid, bidValue, minBid, maxBid);
  const errorMessage =
    bid < +displayMinBid
      ? `Minimum bid is $${displayMinBid}`
      : bid > maxBid
      ? 'Bid is too high'
      : '';

  const handleBidChange = (e) => {
    setBid(trimDecimal(e.target.value, isCpm));
  };

  const handleBlur = (e) => {
    const currentBid = e.target.value;
    if (currentBid.startsWith('.')) {
      setBid(trimDecimal('0' + currentBid));
    }
  };

  const handleSave = async () => {
    const bidToSave = bid.toString().startsWith('.') ? trimDecimal('0' + bid) : bid;
    if (isInvalidBid(bid, bidValue, minBid, maxBid)) return;

    const res = await updateCampaignBid({
      campaignId: cmp_id,
      bid: bidToSave,
    });

    if (res?.data?.success) closeAction();
  };

  useEffect(() => {
    if (bidValue !== bid) {
      setBid(bidValue);
    }
  }, [bidValue]);

  useEffect(() => {
    if (result.isSuccess || result.isError) {
      showPolipop(result);
    }
  }, [result]);

  return (
    <S.PopUpBox>
      {result.isLoading && <Loader.Global delay={0} />}
      <S.FlexWrap>
        <Label text='Bid:' variant='label' style={{ height: '40px' }} />
        <Bid.Big
          value={bid}
          onChange={handleBidChange}
          onBlur={handleBlur}
          error={isError || isMinBidWarning}
          errorMesage={errorMessage}
        />
        {/* <S.FlexWrap style={{ padding: '4px 0' }}>
          <LampIcon style={{ alignSelf: 'start', minWidth: '16px', minHeight: '16px' }} />
          <p style={{ fontSize: '12px', maxWidth: '135px' }}>
            Minimum recommended Bid per location - <strong>${minBid}</strong>
          </p>
        </S.FlexWrap> */}
      </S.FlexWrap>
      <S.FlexWrap>
        <Buttons.SecondaryNormal id='closeModalId' style={{ width: '100%' }} onClick={closeAction}>
          Cancel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='saveModalId'
          style={{ width: '100%' }}
          onClick={handleSave}
          fullWidth={true}
          isDisabled={isDisabled}
        >
          Ok
        </Buttons.PrimaryNormal>
      </S.FlexWrap>
    </S.PopUpBox>
  );
};
